import React from 'react'
import { Routes, Route } from 'react-router-dom'
import styled from 'styled-components'
import { Layout } from 'antd'
import {
  SettingOutlined,
  IdcardOutlined,
  HistoryOutlined
} from '@ant-design/icons'
import ClassTicketSettingPage from './ClassTicketSettingPage'
import ClassTicketRecordsPage from './ClassTicketRecordsPage'
import ClassTicketIssuanceRecordsPage from './ClassTicketIssuanceRecordsPage'
import PillTabs from '../components/PillTabs'

const { Content } = Layout

const ManagementContainer = styled(Layout)`
  min-height: calc(100vh - 120px);
  background: #fff;
`

const TabsHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 80%, transparent 100%);
  backdrop-filter: saturate(180%) blur(8px);
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f5;
`

const ContentWrapper = styled(Content)`
  padding: 0;
  background: transparent;
`

// 堂票主色，與既有頁面一致
const CLASS_TICKET_COLOR = '#d5728a'

const CLASS_TICKET_TABS = [
  {
    key: 'settings',
    label: '堂票設定',
    path: '/class-ticket/settings',
    icon: <SettingOutlined />
  },
  {
    key: 'records',
    label: '堂票紀錄',
    path: '/class-ticket/records',
    icon: <IdcardOutlined />
  },
  {
    key: 'issuances',
    label: '發放紀錄',
    path: '/class-ticket/issuances',
    icon: <HistoryOutlined />
  }
]

const ClassTicketManagementPage = () => {
  return (
    <ManagementContainer>
      <TabsHeader>
        <PillTabs items={CLASS_TICKET_TABS} color={CLASS_TICKET_COLOR} />
      </TabsHeader>
      <ContentWrapper>
        <Routes>
          <Route path='settings' element={<ClassTicketSettingPage />} />
          <Route path='records' element={<ClassTicketRecordsPage />} />
          <Route
            path='issuances'
            element={<ClassTicketIssuanceRecordsPage />}
          />
          <Route path='*' element={<ClassTicketRecordsPage />} />
        </Routes>
      </ContentWrapper>
    </ManagementContainer>
  )
}

export default ClassTicketManagementPage
